import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { IStoreState } from "../../../../../../../../reducers/types";

import {
  getAirlinesMap,
  getAirportMap,
  getConfirmFlightCfarCancellationCallState,
  getFetchFlightCfarInfoCallExpires,
  getFetchFlightCfarInfoCallState,
  getIsMultiCityCfar,
  getSelectedFlightCfarInfo,
  getSelectedFlightCfarItineraryId,
  isFintechCsatEnabledSelector,
} from "../../../../../../reducer/selectors";
import {
  confirmFlightCfarCancellation,
  fetchFlightCfarCancellationInfoV3,
  resetFetchFlightCfarCancellationInfo,
} from "../../../../../../actions/actions";
import { CfarFlightModalContent } from "./component";
import { getDefaultSelectedAccountReferenceIdIfRedemptionEnabled } from "../../../../../../../../modules/rewards/reducer";

const mapStateToProps = (state: IStoreState) => {
  const flightCfarInfoCallExpires = getFetchFlightCfarInfoCallExpires(state);
  return {
    airlineMap: getAirlinesMap(state),
    airportMap: getAirportMap(state),
    confirmFlightCfarCancellationCallState:
      getConfirmFlightCfarCancellationCallState(state),
    fetchFlightCfarInfoCallState: getFetchFlightCfarInfoCallState(state),
    isFetchFlightCfarInfoCallExpired:
      flightCfarInfoCallExpires != null &&
      flightCfarInfoCallExpires < Date.now(),
    selectedCfar: getSelectedFlightCfarInfo(state),
    isMultiCityCfar: getIsMultiCityCfar(state),
    selectedCfarItineraryId: getSelectedFlightCfarItineraryId(state),
    selectedAccountReferenceId:
      getDefaultSelectedAccountReferenceIdIfRedemptionEnabled(state),
    isFintechCsatEnabled: isFintechCsatEnabledSelector(state),
  };
};

const mapDispatchToProps = {
  confirmFlightCfarCancellation,
  fetchFlightCfarCancellationInfoV3,
  resetFetchFlightCfarCancellationInfo,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ICfarFlightModalContentConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedCfarFlightModalContent = connector(
  withRouter(CfarFlightModalContent)
);
